import { FeatureFlagName } from "../../types/feature-flags/featureFlag";
import { FeatureFlagButton } from "../common/FeatureFlags/FeatureFlagButton";
import { t } from "i18next";
import { useAlert } from "../../context/AlertContext";
import { useTranscriptRequest } from "../../hooks/useTranscription";
import LoadingIndicator from "../common/LoadingIndicator/LoadingIndicator";

export function TranscribeButton({
  className = "",
  customerId,
  interactionId,
  onTranscriptionStarted,
}: Readonly<TranscribeButtonProps>) {
  const { mutateAsync: transcribeAsync, isPending } = useTranscriptRequest();
  const showAlert = useAlert();

  const handleRequestTranscript = async () => {
    const result = await transcribeAsync({
      customerId,
      interactionId,
    });
    onTranscriptionStarted?.(result.jobId);
    showAlert(t("transcription:transcriptRequestSubmitted"), "success");
  };

  return (
    <FeatureFlagButton
      featureFlag={FeatureFlagName.Transcription}
      className={className}
      variant="contained"
      onClick={handleRequestTranscript}
      disabled={isPending}
    >
      {isPending && (
        <LoadingIndicator
          sx={{
            height: "1.65em !important",
            width: "1.65em !important",
            marginRight: "0.5em",
          }}
        />
      )}
      Transcribe
    </FeatureFlagButton>
  );
}

export interface TranscribeButtonProps {
  className?: string;
  customerId: string;
  interactionId: string;
  onTranscriptionStarted?: (jobId: string) => void;
}
